export const BACKLOG_API_ERROR_CODE = {
	InternalError: 1,
	LicenceError: 2,
	LicenceExpiredError: 3,
	AccessDeniedError: 4,
	UnauthorizedOperationError: 5,
	NoResourceError: 6,
	InvalidRequestError: 7,
	SpaceOverCapacityError: 8,
	ResourceOverflowError: 9,
	TooLargeFileError: 10,
	AuthenticationError: 11,
	RequiredMFAError: 12,
	TooManyRequestsError: 13,
} as const;

export type BacklogApiErrorCode =
	(typeof BACKLOG_API_ERROR_CODE)[keyof typeof BACKLOG_API_ERROR_CODE];
